<template>
  <form id="acknowledgementForm" @submit.prevent="save()">
    <div class="flex items-center px-4">
      <input
        v-model="isAcknowledged"
        required
        oninvalid="this.setCustomValidity('Please agree to this document to continue.')"
        oninput="this.setCustomValidity('')"
        type="checkbox"
        id="acknowledgement"
        class="sm:h-6 sm:w-6 h-4 w-4"
      />
      <label for="acknowledgement" class="md:text-xl sm:px-4 px-2 text-darkBlue">{{ $t('doc.agree') }} <strong>{{ docInfo?.displayText || docInfo?.title }}</strong></label>
    </div>

    <ContinueBackButtons @back="back" :secondaryButtonContent="'Preview Document'" @secondary="open"></ContinueBackButtons>
  </form>

  <DocumentPreviewModal
    v-if="showPreview"
    :documents="previewDocuments"
    @dismiss="closePreview"
  />
</template>

<script>
import ContinueBackButtons from 'Views/Shared/ContinueBackButtons.vue';
import DocumentPreviewModal from 'Views/Shared/Modal/DocumentPreviewModal.vue';
import { isSafeDocumentPreviewUrl } from '@/utilities/safeDocumentUrl';

export default {
  name: 'DocumentAcknowledgement',
  props: ['docInfo'],
  components: { ContinueBackButtons, DocumentPreviewModal },
  emits: ['save', 'back'],
  data() {
    return {
      isAcknowledged: this.docInfo?.isAcknowledged,
      showPreview: false,
    };
  },
  computed: {
    previewDocuments() {
      return [
        {
          title: this.docInfo?.displayText || this.docInfo?.title || 'Document Preview',
          url: this.docInfo?.docFile?.url || '',
        },
      ];
    },
  },
  methods: {
    save() {
      this.$emit('save', this.isAcknowledged);
    },
    
    back() {
      this.$emit('back');
    },
    open() {
      if (!isSafeDocumentPreviewUrl(this.docInfo?.docFile?.url)) return;
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
    },
  }
};
</script>

<style></style>
